import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function RefundModal({
  open,
  onClose,
  setOpen,
}: AddCategoryModalProps) {

  const navigate = useNavigate();
  
  return (
    <Modal className="modal refund_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Initiate Refund</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group refund_sc">
              <FormControlLabel control={<Checkbox />} label="All" />
              <FormControlLabel control={<Checkbox />} label={
                <>
                  <p>Guest 1</p>
                  <TextField fullWidth hiddenLabel placeholder="Enter Amount" value="AED 500" />
                </>
              } />
              <FormControlLabel control={<Checkbox />} label={
                <>
                  <p>Guest 2</p>
                  <TextField fullWidth hiddenLabel placeholder="Enter Amount" value="AED 500" />
                </>
              } />
              <FormControlLabel control={<Checkbox />} label={
                <>
                  <p>Guest 3</p>
                  <TextField fullWidth hiddenLabel placeholder="Enter Amount" value="AED 500" />
                </>
              } />
              <FormControlLabel control={<Checkbox />} label={
                <>
                  <p>Guest 4</p>
                  <TextField fullWidth hiddenLabel placeholder="Enter Amount" value="AED 500" />
                </>
              } />
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => {setOpen(false); navigate("/manage-cancellation?mode=refunded")}}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
